import React from 'react';
import PropTypes from 'prop-types';
import { Provider as StateProvider } from 'react-redux';
import { ThemeProvider } from '#/theme/Theme';
import AppShell from './AppShell';

const App = ({ store, content }) => {
  return (
    <StateProvider store={store}>
      <ThemeProvider>
        <AppShell>{content}</AppShell>
      </ThemeProvider>
    </StateProvider>
  );
};

App.contextTypes = {
  router: PropTypes.object
};

App.propTypes = {
  content: PropTypes.any,
  store: PropTypes.object
};

export default App;
